import React from 'react';
import { MdLock } from 'react-icons/md';
import { useForm } from 'react-hook-form';
import { Button, InputField } from 'src/shared';

export const EventPasswordAuth = ({ onSubmit, isSubmitting }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    setError: setFormError,
  } = useForm();

  const onSubmitForm = async ({ password }) => {
    try {
      await onSubmit(password);
    } catch (err) {
      setFormError('password', {
        type: 'manual',
        message: 'Incorrect password. Please try again.',
      });
    }
  };

  return (
    <div className="tw-max-w-md tw-mx-auto tw-p-6">
      <div className="tw-text-center tw-mb-6">
        <MdLock className="tw-text-4xl tw-text-primary tw-mx-auto tw-mb-4" />
        <h3 className="tw-text-xl tw-font-semibold tw-mb-2">
          Password Protected Event
        </h3>
        <p className="tw-text-gray-600 tw-mb-6">
          This event requires a password to access. Please enter the password
          below.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmitForm)}>
        <InputField
          {...register('password', { required: 'Password is required' })}
          type="password"
          className="mb-20"
          $label="Password"
          error={errors.password?.message}
          isTouched={touchedFields.password}
        />
        <div className="tw-flex tw-justify-center">
          <Button type="submit" $loading={isSubmitting}>
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};
